import Label from 'components/_parts/atoms/label';

function TextArea({
  id = '', name, style, placeholder, className, isError, validateMessage, ...props
}) {
  return (
    <>
      <div className="layout_textArea floatTextArea">
        <textarea
          id={id}
          className={`custom_text_area floatTextArea_input ${className}`}
          style={style}
          name={name}
          placeholder=" "
          {...props}
        />
        <label htmlFor={id}>{placeholder}</label>
      </div>
      {isError ? (
        <Label className="error d-block text-left maxWidth250px label_error">
          {validateMessage}
        </Label>
      ) : null}
    </>
  );
}

export default TextArea;
